import { IconButton } from "../Buttons";

/**
 * BackButton - Back arrow button for navigation
 * 
 * @param {Object} props
 * @param {function} props.onBack - Back button click handler
 * @param {boolean} props.moveToDirectoryScreen - Flag for directory navigation
 */
const BackButton = ({ onBack, moveToDirectoryScreen }) => {
  const backIcon = (
    <svg
      viewBox="6 4 16 16"
      width="48"
      height="48"
      style={{ color: "#0D6EFD" }}
    >
      <path
        d="M10 12h10M10 12l4-4M10 12l4 4"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const handleClick = () => {
    if (onBack) {
      onBack();
    } else {
    }
  };

  return (
    <IconButton
      icon={backIcon}
      onClick={handleClick}
      className="back-button"
      ariaLabel="Go back"
    />
  );
};

export default BackButton;

